import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'bem-cn';

import { User as YandexUser } from '@yandex-lego/user';
import { useUserContext } from '../../../contexts';

import { RoutePaths } from '../../../constants';

import { Icon, Link, Stack } from '../../UI';
import { ScreenSize, useGetScreenSize } from '../../../hooks';

import { HeaderProfileProps } from './HeaderProfile.types';
import './HeaderProfile.scss';

const b = cn('header');

export const HeaderProfile: React.FC<HeaderProfileProps> = ({ className }) => {
    const location = useLocation();
    const { user } = useUserContext();

    const screenSize = useGetScreenSize();
    const isMobile = screenSize === ScreenSize.Mobile;
    const avatarSize: [number, number] = isMobile ? [32, 32] : [40, 40];

    const [passportLink, setPassportLink] = useState<string>('https://passport.yandex.ru/auth/welcome');

    useEffect(() => {
        const retpath = encodeURIComponent(window.location.href);

        if (process.env.NODE_ENV === 'development') {
            setPassportLink(`https://passport-test.yandex.ru/auth/welcome?mode=auth&retpath=${retpath}`);

            return;
        }

        setPassportLink(`https://passport.yandex.ru/auth/welcome?mode=auth&retpath=${retpath}`);
    }, []);

    // TODO: Добавить проп для управления цветом кнопки "Войти"
    // Сейчас цвет определяется по pathname, что не работает для 404 страниц
    // Нужно добавить проп theme или variant в HeaderProfileProps
    // и передавать его из NotFoundLayout для корректного отображения серой кнопки
    const isAuthButtonWhite = () => {
        return (
            location.pathname === '/' ||
            location.pathname.startsWith('/c/') ||
            location.pathname.startsWith('/prompts/')
        );
    };

    return (
        <div className={b('profile').mix(className)}>
            {user.isAuth ? (
                <Stack spacing={isMobile ? 24 : 32} direction="row" alignItems="center">
                    <Link to={RoutePaths.ProfilePrompts}>
                        <Stack spacing={8} direction="row" alignItems="center" className={b('link')}>
                            <Icon name="terminal" size={24} />
                            <p>Профиль</p>
                        </Stack>
                    </Link>
                    <YandexUser fetchUserData avatarSize={avatarSize} />
                </Stack>
            ) : (
                <a className={b('auth-button', { white: isAuthButtonWhite() })} href={passportLink}>
                    Войти
                </a>
            )}
        </div>
    );
};
